(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:ProdutividadeCtrl
   * @description
   * # ProdutividadeCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('ProdutividadeCtrl', ProdutividadeController);

  /**
   * ProdutividadeController dependencies
   * @type {Array}
   */
  ProdutividadeController.$inject = [
    '$scope',
    '$rootScope',
    '$location',
    'Flash',
    'LoadingService',
    'SafrasService',
    'AtividadesService',
    'PeriodosService',
    '$q',
    'GraficoProdutividade'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function ProdutividadeController($scope, $rootScope, $location, Flash, LoadingService,
    SafrasService, AtividadesService, PeriodosService, $q, GraficoProdutividade) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.safras = [];
    vm.propriedades = [];
    vm.atividades = [];
    vm.periodosAgricolas = [];
    vm.unidades = [
      { descricao: 'Sacas de 60Kg', conversao: 1, abreviatura: 'Sc/ha' },
      { descricao: 'Sacas de 50Kg', conversao: 1.2, abreviatura: 'Sc50/ha' },
      { descricao: 'Quilograma', conversao: 60, abreviatura: 'Kg/ha' }
    ];
    vm.informacoes = [
      { descricao: 'ATR Médio', id: 'atr_medio' },
      { descricao: 'Peso', id: 'peso' }
    ];
    vm.filter = {
      safra_inicial: null,
      safra_final: null,
      atividade: null,
      periodo: null,
      quebra: 'safra',
      tipo: null,
      melhor_media: false,
      propriedades: [],
      unidade: vm.unidades[0],
      informacao: vm.informacoes[1],
      isCana: false
    };
    vm.error = null;
    vm.tipos = [];
    vm.chart = null;
    vm.datePickerOptions = {
      showWeeks: false
    };

    vm.popupData = {
      openedDataInicial: false,
      openedDataFinal: false,
      format: 'dd/MM/yyyy'
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.showChart = showChart;
    vm.openPopupData = openPopupData;
    vm.clearFilterDatas = clearFilterDatas;
    vm.handleUnidades = handleUnidades;

    //////////////////////////////////////////
    // Function declarations

    function handleUnidades() {
      vm.filter.isCana = AtividadesService.isCana(vm.filter.atividade.descricao);

      if (vm.filter.isCana) {
        vm.unidades = [
          { descricao: 'Tonelada', conversao: 1, abreviatura: 'Ton/ha' }
        ];
      } else {
        vm.unidades = [
          { descricao: 'Sacas de 60Kg', conversao: 1, abreviatura: 'Sc/ha' },
          { descricao: 'Sacas de 50Kg', conversao: 1.2, abreviatura: 'Sc50/ha' },
          { descricao: 'Quilograma', conversao: 60, abreviatura: 'Kg/ha' }
        ];
      }
    }

    function showChart() {
      return vm.filter.safra_inicial && vm.filter.safra_final && vm.filter.atividade;
    }

    function addWatch() {
      $scope.$watchCollection('prod.filter', function(newValue) {
        if (hasFilters(newValue)) {
          if (new Date(newValue.safra_inicial.data_inicial) > new Date(newValue.safra_final.data_final)) {
            vm.error = 'Safra final precisa ser maior que safra inicial';
            return;
          }

          if (new Date(newValue.dataInicial) > new Date(newValue.dataFinal)) {
            vm.error = 'Período de Colheita final precisa ser maior que Período de Colheita inicial';
            return;
          }

          vm.error = null;

          if (newValue.safra_inicial.id === newValue.safra_final.id) {
            vm.tipos = ['Talhão', 'Cultivar'];
          } else {
            vm.tipos = ['Safra', 'Talhão', 'Talhão por Safra', 'Cultivar'];
          }

          if (vm.tipos.indexOf(vm.filter.tipo) < 0) {
            vm.filter.tipo = vm.tipos[0];
            return;
          }

          loadData(newValue);
        } else {
          vm.chart = GraficoProdutividade.createChartObject();
        }
      });
    }

    function hasFilters(newValue) {
      return newValue && newValue.safra_inicial && newValue.safra_final && newValue.atividade;
    }

    function loadData(newValue) {
      let promise;

      if (newValue.tipo === 'Cultivar') {
        promise = GraficoProdutividade.chart.cultivar(vm.filter);
      } else if (newValue.tipo === 'Talhão') {
        promise = GraficoProdutividade.chart.glebas(vm.filter);
      } else if (newValue.tipo === 'Talhão por Safra') {
        promise = GraficoProdutividade.chart.glebasPorSafra(vm.filter);
      } else if (newValue.tipo === 'Safra') {
        promise = GraficoProdutividade.chart.safras(vm.filter);
      } else {
        promise = $q.reject('Tipo de gráfico inexistente');
      }

      promise.then(function(chart) {
        vm.chart = chart;
      }).catch(function(error) {
        vm.chart = GraficoProdutividade.createChartObject();
        console.error('Falha ao gerar o gráfico:', error);
        if (error === 'empty') {
          vm.error = 'Não há dados para as safras e cultura selecionadas.';
        } else {
          vm.error = 'Falha ao gerar o gráfico';
        }
      });
    }

    function openPopupData(popup) {
      vm.popupData[popup] = true;
    }

    function clearFilterDatas() {
      vm.filter.dataInicial = null;
      vm.filter.dataFinal = null;
    }

    //////////////////////////////////////////
    // Controller logic
    $rootScope.bodyClass = 'gray-bg';

    LoadingService.showLoading();

    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.produtividade.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
      } else {
        vm.propriedades = $rootScope.propriedades;
        vm.filter.propriedades.push(vm.propriedades.find((propriedade) => (
          propriedade.id === $rootScope.currentPropriedade.id
        )));
        const promises = [];
        promises.push(SafrasService.listAll().then(function(result) {
          vm.safras = result.data;
        }));

        promises.push(AtividadesService.listComEmpreendimento().then(function(atividades) {
          vm.atividades = atividades.data;
        }));

        promises.push(PeriodosService.list().then(function(periodos) {
          vm.periodosAgricolas = periodos.data;
        }));

        $q.all(promises).finally(LoadingService.hideLoading);

        vm.chart = GraficoProdutividade.createChartObject();

        addWatch();
      }
    }, $rootScope.errorRootInitialize);
  }
}());
